import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { RegiaoSituacao, regiaoSituacoes } from '../regiao-situacao';
import { RegiaoSituacaoSelect } from './regiao-situacao-select';

@Component({
    selector: 'sgt-regiao-situacao-select',
    templateUrl: './regiao-situacao-select.component.html',
    styleUrls: ['./regiao-situacao-select.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RegiaoSituacaoSelectComponent), multi: true },
    ]
})
export class RegiaoSituacaoSelectComponent {
    /** ID da situação da região */
    @Input() ngModel: number;
    /** Ao alterar situação da região */
    @Output() ngModelChange = new EventEmitter<number>();

    /** Situações das regiões disponíveis no select */
    @Input() situacoes: RegiaoSituacao[] = regiaoSituacoes;

    /** Nome do input */
    @Input() name: string;
    /* ID do input */
    @Input() id: string;
    /* Se o valor é obrigatório */
    @Input() required: any;
    /* Se deve desabilitar o input */
    @Input() disabled: boolean;
    /** Se deve setar o focus automaticamente */
    @Input() autofocus = false;
    /** Se pode selecionar nenhuma opção */
    @Input() canSelectNull = true;

    @ViewChild('select') select: ElementRef;

    propagateChange: any = () => {};

    /** Ao alterar a situação da região */
    onChange(id: number) {
        this.ngModel = id;
        this.ngModelChange.emit(this.ngModel);
        this.propagateChange(this.ngModel);
    }

    /** Seta o focus no select */
    setFocus() {
        jQuery(this.select?.nativeElement).trigger('focus');
    }

    writeValue(value: number) { }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}
}
